// 历史记录
export default {
    playback: 'History playback',
    flyrecords: 'Flight records',
    flyplay: 'Flight record playback',
    video: 'video',
    photo: 'Photo',
    shoottime: 'Shooting Time',
    min: 'minimum',
    max: 'maximum',
    select: "Choice",
    manydowland: 'Bulk download',
    photosize: 'Picture Size',
    videosize: 'Video Duration',
    download: 'Download',
    manydelophoto: 'This operation will permanently delete the selected picture. Do you want to continue',
    videoplay: 'Video playback',
    delovideo: 'This operation will permanently delete this video. Do you want to continue',
    mustthree: 'Up to three Downloads',
    manydelovideo: 'This operation will permanently delete the selected video. Do you want to continue',
    tip_err1: 'The current limit is 99 files, and {0} files are selected this time.',
    tip_err2: 'Picture format error, please upload again!',
    tip_err3: 'Picture size cannot exceed 10MB!',
}